"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonAccessDenied = exports.OktonCan = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const lu_1 = require("react-icons/lu");
const OktonPlatformProvider_1 = require("../../platform/OktonPlatformProvider");
const OktonCan = ({ capability, fallback = null, children, }) => {
    const { can } = (0, OktonPlatformProvider_1.useOktonCapabilities)();
    return can(capability) ? react_2.default.createElement(react_2.default.Fragment, null, children) : react_2.default.createElement(react_2.default.Fragment, null, fallback);
};
exports.OktonCan = OktonCan;
const OktonAccessDenied = ({ title = "Acesso restrito", description = "Você não tem permissão para acessar esta página. Solicite autorização ao administrador.", minH = "60vh", actionLabel, onAction, }) => {
    const cardBg = (0, react_1.useColorModeValue)("white", "gray.800");
    const borderColor = (0, react_1.useColorModeValue)("gray.200", "gray.700");
    const mutedColor = (0, react_1.useColorModeValue)("gray.600", "gray.400");
    return (react_2.default.createElement(react_1.Flex, { align: "center", justify: "center", minH: minH, p: "6" },
        react_2.default.createElement(react_1.Box, { bg: cardBg, borderWidth: "1px", borderColor: borderColor, borderRadius: "xl", p: "8", boxShadow: "sm", maxW: "560px", textAlign: "center" },
            react_2.default.createElement(react_1.Flex, { justify: "center", mb: "4" },
                react_2.default.createElement(react_1.Icon, { as: lu_1.LuLockKeyhole, boxSize: "8", color: "blue.500" })),
            react_2.default.createElement(react_1.Heading, { fontSize: "2xl", mb: "3" }, title),
            react_2.default.createElement(react_1.Text, { color: mutedColor }, description),
            actionLabel && onAction ? (react_2.default.createElement(react_1.Button, { mt: "5", colorScheme: "blue", onClick: onAction }, actionLabel)) : null)));
};
exports.OktonAccessDenied = OktonAccessDenied;
//# sourceMappingURL=index.js.map